
(async () => {
  const fetchTraits = async () => {
    try { 
      const chart_container = document.querySelector('#traits-table');
      chart_container.style.display = 'none';

      const spinner = document.querySelector('#loading-spinner-traits');
      spinner.style.display = 'block';

      const response = await axios.get('https://api.pandastats.io/traits?$filter=Category%20ne%20%27Honorary%27 and Category%20ne%20%271 of 1%27');

      chart_container.style.display = 'table';
      spinner.style.display = 'none';
      

      if (response.status === 200) {
        const traits_table = response.data;      

          $('#traits-table').DataTable({
              data: traits_table,
              "bLengthChange": false,
              "pageLength": 10,
              columns: [
                  { title: '', data: 'Name', orderable: false, className: 'p-1',
                  render: function (data, type, row, meta) {
                    if (type === 'display') {
                        const collectionPrefix = row.Collection === "Infinity" ? 'infinity/' : '';
                        const imageUrl = `https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/${collectionPrefix}${row.Category}/${data}-100x100.png?r=${Math.floor(Math.random() * 100000)}`;
                        const tooltipImageUrl = `https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/${collectionPrefix}${row.Category}/${data}-100x100.png?r=${Math.floor(Math.random() * 100000)}`;
                
                        return `<img src="${imageUrl}" width="50px" data-bs-toggle="tooltip" data-bs-id="${row.Id}" data-bs-placement="top" data-tooltip="<div style='background-color:white;'><img src='${tooltipImageUrl}' width='120px'/></div>" data-bs-html="true" />`;
                    }
                    return data;
                },
                  },
                  { title: 'Name', data: 'Name', className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                      return type === 'display'
                          ? '<a href="trait.html?id=' + row.Id + '">' + data + '</a>'
                          : data;
                    },
                  },
                  { title: 'Category', data: 'Category' },
                  {
                    title: 'Premium',
                    data: 'TraitPremium',
                    className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                        const premium = row.TraitPremium;
                        let displayText = '-';
                        let textColorClass = '';
            
                        displayText = `+${premium.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 1 })}%`;
                        textColorClass = 'text-success';

            
                        return type === 'display'
                            ? `<span class="${textColorClass}">${displayText}</span>`
                            : premium;
                    },
                  },
                  { title: 'Rarity Class', data: 'RarityClass', render: function(data) {
                    return data ? data.charAt(0).toUpperCase() + data.slice(1) : '-';
                  }},
                  { title: 'Price', data: 'Price', 
                    render: function(data, type, row, meta) {
                      if (data === 0) {
                        return '-';
                      }
                      return parseFloat(data).toLocaleString();
                    } 
                  },
                  { title: 'Supply', data: 'Quantity', className: 'dt-body-left', render: $.fn.dataTable.render.number(',', '.', 0, '') },
                  {
                    title: 'Supply Sold',
                    data: 'Quantityused', 
                    className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                      const percentage = (data/row.Quantity * 100).toFixed(Number.isInteger(data/row.Quantity) ? 0 : 1);
                      const displayPercentage = Number.isInteger(data/row.Quantity) ? percentage + '%' : percentage + '%';
                      return type === 'display'
                        ? '<div class="mb-3 progress" style="height: 14px;"><div role="progressbar" class="progress-bar bg-success" aria-valuenow="' + data + '" aria-valuemin="0" aria-valuemax="' + row.Quantity + '" style="width: ' + percentage + '%; overflow: visible;"><span class="fs-12 fw-bold">' + displayPercentage + '</span></div></div>'
                        : data;
                    },
                    
                  },

              ],
              initComplete: function () {
                createTooltips();
              },
              drawCallback: function() {
                createTooltips();
              }
            });
            

      } else {
        console.error('Error fetching data:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  function createTooltips() {
    const tooltips = $('#traits-table').find('[data-bs-id]');
  
    // Create new tooltips
    tooltips.each(function () {
      const content = $(this).attr('data-tooltip');
      const id = $(this).attr('data-bs-id');
  
      $(this).attr('data-bs-html', true);    // Use boolean instead of string
      new bootstrap.Tooltip(this, {
        id: id,
        placement: 'top',
        html: true,
        sanitizeFn: (content) => content,
        title: content
      });
    });
  }
  

  fetchTraits();
})();